// extracted by mini-css-extract-plugin
module.exports = {"popupWrapper":"SubmitPopup-module--popupWrapper--3E9uj","popup":"SubmitPopup-module--popup--2YfB-","closeBtn":"SubmitPopup-module--closeBtn--3u0tY"};